<template>
  <div>
    <q-card v-for="item in data" :key="item.id" class="q-mb-sm">
      <offer-object
        :data="item"
        use-max-count
        change-detection
        @click="handleClick(item)"
      />
    </q-card>
  </div>
</template>

<script>
// Components
import OfferObject from './offer-object.vue'

export default {
  name: 'DynamicOfferCollection',
  emits: ['click'],
  components: {
    OfferObject
  },
  props: {
    data: {
      type: Array,
      default () {
        return []
      }
    },
    rawData: {
      type: Object,
      default () {
        return {}
      }
    }
  },
  methods: {
    handleClick (data) {
      const event = {
        type: 'Orderadmin\\Products\\Entity\\Product\\Offer',
        event: 'storage.tasks.task.offer.opened',
        data: {
          ...data,
          componentType: 'collection'
        }
      }

      this.$emit('click', event)
    }
  }
}
</script>
